// const Countdown = () => {
//   const now = new Date();
//   const countDate = new Date("August 31 2026 23:59:59 GMT-0400").getTime();
//   const gap = countDate - now;

//   const second = 1000;
//   const minute = second * 60;
//   const hour = minute * 60;
//   const day = hour * 24;

//   const textDay = Math.floor(gap / day);
//   const textHour = Math.floor((gap % day) / hour);
//   const textMinute = Math.floor((gap % hour) / minute);
//   const textSecond = Math.floor((gap % minute) / second);
//   const textMillisecond = (gap % 1000) / 1000;
//   const msString = String(Math.floor(textMillisecond * 100)).padStart(2, "0"); // Truncate to 2 digits

//   const pad = (num, digits = 2) => String(num).padStart(digits, "0");

//   if (gap >= 0){
//     document.querySelector('.day').innerText = pad(textDay);
//     document.querySelector('.hour').innerText = pad(textHour);
//     document.querySelector('.minute').innerText = pad(textMinute);

//     const dayContainer = document.querySelector('.container-day');
//     const secondEl = document.querySelector('.second');
//       // Add seconds + millisecond span
//       secondEl.innerHTML = `${pad(textSecond)}<span class="ms">.${msString}</span>`;
//   }
// };

// setInterval(Countdown, 25);


(function () {
    function initializeLgndCountdown() {
      var root = document.getElementById("lgnd-fixed-countdown");

      if (!root || root.dataset.countdownInitialized === "true") return;

      var endSeconds = Number(root.getAttribute("data-countdown-end"));
      var timer = root.querySelector(".lgnd-countdown__timer");
      var expiredMessage = root.querySelector("[data-countdown-expired]");

      if (!endSeconds || !timer) return;

      var endTime = endSeconds * 1000;
      var reducedMotion =
        window.matchMedia &&
        window.matchMedia("(prefers-reduced-motion: reduce)").matches;

      var units = {
        days: root.querySelector('[data-countdown-unit="days"]'),
        hours: root.querySelector('[data-countdown-unit="hours"]'),
        minutes: root.querySelector('[data-countdown-unit="minutes"]'),
        seconds: root.querySelector('[data-countdown-unit="seconds"]')
      };

      if (!units.days || !units.hours || !units.minutes || !units.seconds) {
        return;
      }

      root.dataset.countdownInitialized = "true";

      function pad(number) {
        return String(Math.max(0, number)).padStart(2, "0");
      }

      function setUnit(unit, nextValue, animate) {
        var card = unit.querySelector(".lgnd-flip-card");
        var staticTop = unit.querySelector("[data-countdown-static-top]");
        var staticBottom = unit.querySelector("[data-countdown-static-bottom]");
        var flipTop = unit.querySelector("[data-countdown-flip-top]");
        var flipBottom = unit.querySelector("[data-countdown-flip-bottom]");

        if (
          !card ||
          !staticTop ||
          !staticBottom ||
          !flipTop ||
          !flipBottom
        ) {
          return;
        }

        var currentValue = unit.dataset.currentValue;

        if (currentValue === nextValue) return;

        if (!currentValue || !animate || reducedMotion) {
          staticTop.textContent = nextValue;
          staticBottom.textContent = nextValue;
          flipTop.textContent = nextValue;
          flipBottom.textContent = nextValue;
          unit.dataset.currentValue = nextValue;
          return;
        }

        card.classList.remove("is-flipping");
        void card.offsetWidth;

        flipTop.textContent = currentValue;
        flipBottom.textContent = nextValue;
        staticTop.textContent = nextValue;

        card.classList.add("is-flipping");

        window.setTimeout(function () {
          staticBottom.textContent = nextValue;
        }, 320);

        window.setTimeout(function () {
          card.classList.remove("is-flipping");
          flipTop.textContent = nextValue;
          flipBottom.textContent = nextValue;
        }, 680);

        unit.dataset.currentValue = nextValue;
      }

      function updateCountdown(animate) {
        var gap = Math.max(0, endTime - Date.now());

        var second = 1000;
        var minute = second * 60;
        var hour = minute * 60;
        var day = hour * 24;

        var values = {
          days: pad(Math.floor(gap / day)),
          hours: pad(Math.floor((gap % day) / hour)),
          minutes: pad(Math.floor((gap % hour) / minute)),
          seconds: pad(Math.floor((gap % minute) / second))
        };

        setUnit(units.days, values.days, animate);
        setUnit(units.hours, values.hours, animate);
        setUnit(units.minutes, values.minutes, animate);
        setUnit(units.seconds, values.seconds, animate);

        if (gap <= 0) {
          window.clearInterval(interval);

          if (expiredMessage) {
            expiredMessage.hidden = false;
          }
        }
      }

      var interval = null;

      /*
       * Liquid supplies the initial countdown values in the HTML.
       * JavaScript begins updating after the section has loaded.
       */
      updateCountdown(false);
      interval = window.setInterval(function () {
        updateCountdown(true);
      }, 1000);
    }

    if (document.readyState === "loading") {
      document.addEventListener(
        "DOMContentLoaded",
        initializeLgndCountdown,
        { once: true }
      );
    } else {
      initializeLgndCountdown();
    }

    /*
     * GemPages can inject custom-code sections after DOMContentLoaded.
     * This provides one additional safe initialization attempt.
     */
    window.setTimeout(initializeLgndCountdown, 500);
  })();









  

var progress = document.querySelector('.progress');

let progressBar = document.getElementById("progressBAR");

  // Update the count down every 1 second
  var x = setInterval(function() {
    
  var begin = new Date("August 30, 2026 00:00:00").getTime();
  var end = new Date("September 31, 2026 23:59:59").getTime();

  // Get today's date and time
  var now = new Date();
  var localTime = now.getTime();
  var localOffset = now.getTimezoneOffset() * 60000;
  
  var utc = localTime + localOffset;
  // var offset = -5;   
  var offset = -4;
  var newyork = utc + (3600000*offset);

  var nowNewYork = new Date(newyork); 
    
  // nowActual is relative to beginning date of giveaway
  var nowActual = nowNewYork.getTime() - begin;

  // Find the distance between now and the count down date
  var distance = end - nowNewYork;
    
  // FULL DURATION NARROWS TIME FROM END TO BEGINNING
  var fullDuration = end - begin;
  // GET FRACTION OF ACTUAL CURRENT TIME DIVIDED BY FULL DURATION
  var timeLeft = nowActual/fullDuration;

  // Time calculations for days, hours, minutes and seconds
  var days = Math.floor(distance / (1000 * 60 * 60 * 24));
  var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
  var seconds = Math.floor((distance % (1000 * 60)) / 1000);

  // USE TO CHECK Dates in Number Formats
  // console.log(end2);
  // console.log(fullDuration2);
  // console.log(timeLeft2);
    
  // If time is UP or NOT BEGUN set progress bar to full, else fill it appropriately!
  if (timeLeft >= 1){
      progress.style.width = (100 + '%');
      progress.style.opacity = 1;
  } else if (timeLeft <= 0) {
    progress.style.width = (100 + '%');
    progress.style.opacity = 1;
  } else { 
      if ((timeLeft*100) > 60){
        progressBar.style.display = 'block';
         progress.style.width = (60 + (timeLeft*40) + '%');
        progress.style.opacity = 1;
      }
  }
 
}, 1000);



// const scriptURL = 'https://script.google.com/macros/s/AKfycbz2BOcsifI7fdB-yWPgA3riBOBwigQyDsFaQ7wxjQncBmkS04oA8gBStVi2FlSSrGtS_g/exec'

//   const form = document.forms['hc-form'];
//   const popUpContainer = document.getElementById("popUpMobile");
//   const initial = document.getElementById("initial-form");
//   const after = document.getElementById("after-form");
  
//   // Function to handle the form submission
//     function submitForm() {
//         fetch(scriptURL, { method: 'POST', body: new FormData(form) })
//             .then(response => console.log('Success!', response))
//             .catch(error => console.error('Error!', error.message));
//     }
    
//     // function handleSubmit(){
//     //   // initial.classList.toggle("hide");
//     //   //       after.classList.toggle("hide");
//     //         // console.log("SHOULD HIDE NOW!!");
//     //         submitForm(); // Submit form via fetch
//     // }
    
    

// document.addEventListener('DOMContentLoaded', function () {

//     // Add change event listeners to radio buttons
//     const radioButtons = form.querySelectorAll('input[type="radio"]');
//     radioButtons.forEach(radio => {
//         radio.addEventListener('change', function (e) {
//           initial.style.display = "none";
//             after.classList.toggle("hide");
//             console.log("Form button clicked, hiding buttons")
//           submitForm();
//         });
//     });
// });

document.addEventListener('DOMContentLoaded', function () {
  const form = document.forms['hc-form'];
  const initial = document.getElementById("initial-form");
  const after = document.getElementById("after-form");

  let hasSubmitted = false;

  function submitForm() {
    if (hasSubmitted) return;

    hasSubmitted = true;

    fetch(scriptURL, {
      method: 'POST',
      body: new FormData(form)
    })
      .then(response => console.log('Success!', response))
      .catch(error => {
        console.error('Error!', error.message);
        hasSubmitted = false; // allow retry if it fails
      });
  }

  const radioButtons = form.querySelectorAll('input[type="radio"]');

  radioButtons.forEach(radio => {
    radio.addEventListener('change', function () {
      if (hasSubmitted) return;

      initial.style.display = "none";
      after.classList.remove("hide");

      console.log("Form button clicked, hiding buttons");

      submitForm();
    });
  });
});